export default __webpack_public_path__ + "497ea50aa9455a0241a81a7d496546f2.svg";